export const QUOTE_VERSION_STATUS = Object.freeze({
  DRAFT: 'draft',
  VALIDATED: 'validated',
  ISSUED: 'issued',
  SUPERSEDED: 'superseded',
  ACCEPTED: 'accepted',
  REFUSED: 'refused',
  CANCELLED: 'cancelled',
  EXPIRED: 'expired',
});

export const QUOTE_VERSION_STATUS_LABELS = Object.freeze({
  [QUOTE_VERSION_STATUS.DRAFT]: 'Brouillon',
  [QUOTE_VERSION_STATUS.VALIDATED]: 'Validée',
  [QUOTE_VERSION_STATUS.ISSUED]: 'Éditée',
  [QUOTE_VERSION_STATUS.SUPERSEDED]: 'Remplacée',
  [QUOTE_VERSION_STATUS.ACCEPTED]: 'Acceptée',
  [QUOTE_VERSION_STATUS.REFUSED]: 'Refusée',
  [QUOTE_VERSION_STATUS.CANCELLED]: 'Annulée',
  [QUOTE_VERSION_STATUS.EXPIRED]: 'Expirée',
});

export const QUOTE_VERSION_STATUSES = Object.freeze(
  Object.values(QUOTE_VERSION_STATUS)
);

export const isQuoteVersionEditable = (status) =>
  status === QUOTE_VERSION_STATUS.DRAFT;

export const isQuoteVersionOfficial = (status) => [
  QUOTE_VERSION_STATUS.ISSUED,
  QUOTE_VERSION_STATUS.SUPERSEDED,
  QUOTE_VERSION_STATUS.ACCEPTED,
  QUOTE_VERSION_STATUS.REFUSED,
  QUOTE_VERSION_STATUS.CANCELLED,
  QUOTE_VERSION_STATUS.EXPIRED,
].includes(status);
